import { Users, AlertTriangle, Heart, Shield, Phone, CheckCircle2, UserCheck } from 'lucide-react';

/* ─── Alcance Politico — O card que empolgra o prefeito ─── */

interface FamiliasData {
  totalResponsaveis: number;
  comContaAtiva: number;
  comContaPendente: number;
  semConta: number;
  taxaAtivacao: number;
  totalVinculos: number;
  recebemNotificacao: number;
  taxaCobertura: number;
  totalAlunosSemResponsavel: number;
}

export function AlcancePoliticoCard({ familias, totalAlunos }: { familias: FamiliasData; totalAlunos: number }) {
  const alcanceTotal = familias.comContaAtiva + familias.comContaPendente;
  const pctAlcance = familias.totalResponsaveis > 0
    ? Math.round((alcanceTotal / familias.totalResponsaveis) * 100)
    : 0;

  return (
    <div className="muni-alcance">
      <div className="muni-alcance-header">
        <Heart size={20} style={{ color: '#e11d48' }} />
        <div>
          <h3 className="muni-alcance-title">Alcance da Prefeitura</h3>
          <p className="muni-alcance-sub">Familias conectadas a rede municipal</p>
        </div>
      </div>

      {/* Big Numbers */}
      <div className="muni-alcance-big-grid">
        <div className="muni-alcance-big">
          <div className="muni-alcance-big-value" style={{ color: '#1e40af' }}>
            {familias.totalResponsaveis.toLocaleString('pt-BR')}
          </div>
          <div className="muni-alcance-big-label">
            <Users size={13} /> Familias Cadastradas
          </div>
        </div>
        <div className="muni-alcance-big">
          <div className="muni-alcance-big-value" style={{ color: '#10b981' }}>
            {familias.comContaAtiva.toLocaleString('pt-BR')}
          </div>
          <div className="muni-alcance-big-label">
            <UserCheck size={13} /> Contas Ativas
          </div>
        </div>
        <div className="muni-alcance-big">
          <div className="muni-alcance-big-value" style={{ color: '#6366f1' }}>
            {familias.recebemNotificacao.toLocaleString('pt-BR')}
          </div>
          <div className="muni-alcance-big-label">
            <Phone size={13} /> Recebem Alertas
          </div>
        </div>
      </div>

      {/* Progress Bars */}
      <div className="muni-alcance-bars">
        <ProgressBar label="Ativacao de Contas" value={familias.taxaAtivacao} color="#10b981" icon={<CheckCircle2 size={13} />} />
        <ProgressBar label="Cobertura (alunos c/ resp.)" value={familias.taxaCobertura} color="#6366f1" icon={<Shield size={13} />} />
        <ProgressBar label="Alcance Total" value={pctAlcance} color="#1e40af" icon={<Heart size={13} />} />
      </div>

      {/* Warnings */}
      <div className="muni-alcance-warnings">
        {familias.comContaPendente > 0 && (
          <div className="muni-alcance-warn pending">
            <AlertTriangle size={14} />
            <span>{familias.comContaPendente} contas pendentes de ativacao</span>
          </div>
        )}
        {familias.totalAlunosSemResponsavel > 0 && (
          <div className="muni-alcance-warn danger">
            <AlertTriangle size={14} />
            <span>{familias.totalAlunosSemResponsavel} alunos sem responsavel vinculado</span>
          </div>
        )}
        {familias.semConta > 0 && (
          <div className="muni-alcance-warn info">
            <Users size={14} />
            <span>{familias.semConta} responsaveis sem conta no app</span>
          </div>
        )}
      </div>
    </div>
  );
}

function ProgressBar({ label, value, color, icon }: { label: string; value: number; color: string; icon: React.ReactNode }) {
  return (
    <div className="muni-alcance-bar-row">
      <div className="muni-alcance-bar-header">
        <span className="muni-alcance-bar-icon" style={{ color }}>{icon}</span>
        <span className="muni-alcance-bar-label">{label}</span>
        <strong className="muni-alcance-bar-pct" style={{ color }}>{value}%</strong>
      </div>
      <div className="muni-alcance-bar-track">
        <div className="muni-alcance-bar-fill" style={{ width: `${Math.min(value, 100)}%`, background: color }} />
      </div>
    </div>
  );
}
